module.exports = __webpack_public_path__ + "static/media/civic-logo-animated.8423c282.svg";